type PropTypes = {
  className?: string
}

const ExpandIcon = ({ className }: PropTypes) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_3143_14264)">
        <rect
          width="14"
          height="14"
          fill="white"
          fillOpacity="0.01"
          style={{ mixBlendMode: 'multiply' }}
        />
        <path d="M8.75 0.875V1.75H11.6314L7.875 5.50462L8.49362 6.125L12.25 2.36863V5.25H13.125V0.875H8.75Z" fill="#585962" />
        <path d="M6.125 8.4945L5.509 7.875L1.75 11.6314V8.75H0.875V13.125H5.25V12.25H2.36863L6.125 8.4945Z" fill="#585962" />
      </g>
      <defs>
        <clipPath id="clip0_3143_14264">
          <rect
            width="14"
            height="14"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ExpandIcon
